/**
 * Created with Mei Zhiwei on 2018-08-06 01:56:42.
 * Description: url
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: fanzhijie
 * @Last Modified time: 2021-04-30 14:22:46
 */
let e = 'localhost';
let root = '';
let passportBaseUrl = '';
let passportConfig = '';
let passportLogout = '';
let bind = '';
let opApiHost = '';

if (location.href.indexOf('localhost') >= 0) {
  root = 'http://localhost:8080/ajax';
  // root = 'http://open.api.test.sankuai.com/ajax'
  passportBaseUrl = 'http://passport.fe.st.sankuai.com/';
  passportConfig = '?service=4c9f6dd4&continue=http%3a%2f%2flocalhost:8080%2fajax%2f';
  passportLogout = 'https://passport.fe.st.sankuai.com/account/signout?service=4c9f6dd4&continue=http%3A%2F%2Flocalhost:8080%2Fajax%2Flogout';
  bind = 'http://localhost:8080/#/register?step=2';
  opApiHost = 'http://localhost:8080';
} else if (location.href.indexOf('.test') >= 0) {
  root = 'http://open.api.test.sankuai.com/ajax';
  e = 'beta';
  passportBaseUrl = 'http://passport.fe.st.sankuai.com/'
  passportConfig = '?service=4c9f6dd4&continue=http%3a%2f%2fopen.api.test.sankuai.com%2fajax%2f';
  passportLogout = 'https://passport.fe.st.sankuai.com/account/signout?service=4c9f6dd4&continue=http%3A%2F%2Fopen.api.test.sankuai.com%2Fajax%2Flogout';
  bind = 'http://open.api.test.sankuai.com/#/register?step=2';
  opApiHost = 'http://api.openplatfrom.test.sankuai.com';
} else if (location.href.indexOf('o.dianping') >= 0) {
  root = 'https://o.dianping.com/ajax';
  e = 'prod';
  passportBaseUrl = 'http://passport.meituan.com/';
  passportConfig = '?service=4c9f6dd4&continue=https%3a%2f%2fo.dianping.com%2fajax%2f';
  passportLogout = 'http://passport.meituan.com/account/signout?service=4c9f6dd4&continue=http%3A%2F%2Fo.dianping.com%2Fajax%2Flogout';
  bind = 'https://o.dianping.com/#/register?step=2';
  opApiHost = 'https://open-api.dianping.com';
} else {
  root = 'https://developer.dianping.com/ajax';
  e = 'prod';
  passportBaseUrl = 'http://passport.meituan.com/';
  passportConfig = '?service=4c9f6dd4&continue=https%3a%2f%2fdeveloper.dianping.com%2fajax%2f';
  passportLogout = 'http://passport.meituan.com/account/signout?service=4c9f6dd4&continue=http%3A%2F%2Fdeveloper.dianping.com%2Fajax%2Flogout';
  bind = 'https://developer.dianping.com/#/register?step=2';
  opApiHost = 'https://open-api.dianping.com';
}
const env = e;
const host = {
  HOME: location.origin,
  BIND: bind,
  LOGIN: passportBaseUrl + 'account/unitivelogin/' + passportConfig + 'callback',
  LOGOUT: root + '/logout',
  REGISTER: passportBaseUrl + 'account/unitivesignup' + passportConfig + 'callback',
  OP_API_HOST: opApiHost,
  PASSPORT_LOGOUT: passportLogout,

  MIGRATE_POINT: root + '/developer/vendor/migrate/confirm',

  CHANGE_ACCOUNT: passportBaseUrl + 'account/unitiveeditaccount' + passportConfig + 'changeAccount',
  CHANGE_PASSWORD: passportBaseUrl + 'account/unitiveeditpassword' + passportConfig + 'changePassword',

  DOC_ALL_BIZ: root + '/doc/biz/all',
  DOC_BIZ_DOC_TREE: root + '/doc/biz/{code}',
  POST_TOC_SHOW: root + '/doc/toc/{id}',
  POST_PARENT_LOAD: root + '/doc/toc/{tocId}/{postId}',
  POST_DETAIL: root + '/doc/{id}',
  POST_ID_APICODE: root + '/doc/apicode/{code}/',

  VENDOR_ALL_URL: root + '/developer/allVendorUrl',
  CURRENT_USER: root + '/user',
  DEVELOPER_USER: root + '/developer/user',

  VENDOR_INFO: root + '/developer/vendor/info',
  VENDOR_APPLICATION: root + '/developer/vendor/applications',
  VENDOR_APPLICATION_CREATE: root + '/developer/vendor/applications/create',
  VENDOR_SECRET: root + '/developer/vendor/appKey/{key}',

  BUSINESS_TREE: root + '/developer/biz',
  API_SHOW_ALL: root + '/developer/apis',
  VENDOR_APIS: root + '/developer/vendor/{id}/apis',
  VENDOR_URLS_UPDATE: root + '/developer/vendor/url/update',

  SIGN_CHECK: root + '/developer/sign/signCheck',
  CALLBACK_URL: root + '/developer/callback/allUrl',
  CALLBACK_CHECK: root + '/developer/callback/check',
  CALLBACK_INIT: root + '/developer/init/callback',
  CALLBACK_DOC: root + '/developer/callback/doc',

  TEST_SHOP_MAPPING: root + '/developer/testShop/{id}/mapping',
  TEST_SHOP_QUERY_INFO: root + '/developer/testShop/{id}/query',
  TEST_SHOP_APPLY: root + '/developer/testShop/{id}/apply',
  TEST_SHOP_EXTEND: root + '/developer/testShop/{id}/extend',
  DEV_API_TEST_INIT: root + '/developer/init/apitest',
  DEV_API_TEST_SUBMIT: root + '/developer/apitest/submit',
  DEV_API_TEST_LINK_DOC: root + '/developer/apitest/doc',

  AUDIT_SETTLE_RECALL: root + '/developer/audit/vendor/recall',
  AUDIT_SETTLE_DETAIL: root + '/developer/audit/vendor/detail',
  AUDIT_SETTLE_LAUNCH: root + '/developer/audit/vendor/launch',
  AUDIT_SETTLE_RELAUNCH: root + '/developer/audit/vendor/relaunch',

  AUDIT_APIS_APPLIED: root + '/developer/audit/{id}/api/applied',
  AUDIT_APIS_LAUNCH: root + '/developer/audit/{id}/api/launch',

  BUSINESS_SETTING_UPDATE: root + '/developer/business/setting/update',
  BUSINESS_SETTING_QUERY: root + '/developer/business/setting/query/{appId}',

  BIZ_SHOP_MAPPING_GENERATE: root + '/developer/biz/shopmapping/jbpurl/generate',

  SDK_JAVA: 'https://link-pan.sankuai.com/plink/Quj-q0vY',
  SDK_JAVA_SECRET: '42aDY0',

  // ----------------------------各种版本的SDK下载 add by songguangming02--------------------
  SDK_BASIC_DOWNLOAD: root + '/sdk/basic/download',
  SDK_FUNCTION_LOAD_FUNCTIONNAME: root + '/sdk/basic/load/functionName',

  // 沙箱
  SANDBOX_VENDOR_AVAILABLE_BIZ: root + '/developer/sandbox/availableBiz/{appId}',
  SANDBOX_VENDOR_BIZTYPE: root + '/developer/sandbox/biztype/{appId}',
  SANDBOX_BIZ_AVAILABLE_SET: root + '/developer/sandbox/availableSet/{bizType}',
  SANDBOX_ADD_VENDOR_BIZ_SET: root + '/developer/sandbox/addVendorBizSet',
  SANDBOX_GRAY_JUDGE: root + '/developer/sandbox/grayJudge',
  SANDBOX_VENDOR_ASSIGNED_QUERY: root + '/developer/sandbox/queryAssignSet/{appId}',
  SANDBOX_BIZ_SCENE_QUERY: root + '/developer/sandbox/scene/query/{bizType}',
  SANDBOX_BIZ_SCENE_CASE_QUERY: root + '/developer/sandbox/scene/case/query',
  SANDBOX_BIZ_SCENE_CASE_ACTIVE: root + '/developer/sandbox/scene/case/active',
  SANDBOX_BIZ_SCENE_TEST_APPKEY_QUERY: root + '/developer/sandbox/scene/testAppKey/{appId}',
  SANDBOX_ENTITY_DATA_FOREIGN_SELECT: root + '/developer/sandbox/entity/dataForeign/query',
  SANDBOX_ENTITY_DATA_SAVE: root + '/developer/sandbox/entity/data/save',
  SANDBOX_VENDOR_TEST_INFO: root + '/developer/sandbox/vendor/testInfo/{appId}',
  SANDBOX_BIZ_ENBTITY_QUERY: root + '/developer/sandbox/biz/entity/query',
  SANDBOX_BIZ_ENBTITY_FOREIGNOPTIONS_QUERY: root + '/developer/sandbox/biz/entity/foreignoptions/query',
  SANDBOX_BIZ_ENBTITY_DATA_QUERY: root + '/developer/sandbox/biz/entity/data/query',
  SANDBOX_BIZ_ENBTITY_DATA_DELETE: root + '/developer/sandbox/biz/entity/data/delete',
  SANDBOX_BIZ_ENBTITY_DATA_SAVE: root + '/developer/sandbox/biz/entity/data/save'
};

export { env, host };



// WEBPACK FOOTER //
// ./src/config/host.js